import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import DepositHistoryPage, { getDefaultPageUI } from "components/pages/DepositHistoryPage";
import { getDepositHistoryItemConfig } from "components/pages/DepositHistoryPage/components/DepositHistoryView";
import Classes, { Account, Deposit } from "model";

export default function CaptureMabiDepositsDepositExpanded(props) {
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, globalController);
    const account = Account.getDefaultBrandedAccountByType("checking");
  
    const deposit = Deposit.init({
        id: 100,
        date: 0,
        account: account.id,
        amount: 20,
        status: "Not Available",
        source: "Mobile Phone",
        isCheck: "true"
    });

    Deposit.create(deposit)
        .submit(Classes);

    const { key, value } = getDepositHistoryItemConfig("100");
    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
        .update([ key ], { ...value, accordionActive: true })
        .submit();
        

    return <DepositHistoryPage ui={ ui } />
}